{
  "schemaVersion": 1,
  "id": "astana",
  "officialCityId": "710000000",
  "names": {
    "ru": "Астана",
    "kk": "Астана",
    "en": "Astana"
  },
  "aliases": ["Астана", "Нур-Султан", "Нұр-Сұлтан", "Целиноград"],
  "bboxId": "astana-city",
  "graphId": "astana-city",
  "bbox": {
    "south": 50.95,
    "west": 71.2,
    "north": 51.3,
    "east": 71.7
  },
  "origin": {
    "lat": 51.125,
    "lon": 71.45
  },
  "view": {
    "center": [71.43, 51.13],
    "zoom": 11.5
  },
  "time": {
    "zone": "Asia/Almaty",
    "utcOffsetMin": 300
  },
  "source": {
    "pbf": "data/pbf/kazakhstan-latest.osm.pbf",
    "extract": "data/pbf/astana-city.osm.pbf",
    "sha256": "53a639fc0cfdb786089050ba4c18c8a25ed91f7758ec71d934a0257a7d056495",
    "replicationTimestamp": "2026-10-11T20:21:06Z",
    "extractObjectTimestamp": "2026-10-11T17:39:01Z"
  },
  "generatedAt": "2026-10-11T17:39:01Z",
  "routingPolicy": "kz-car-assumptions-v1",
  "compiler": {
    "highwayPolicy": "motorway-as-trunk-v1",
    "signalCollapseM": 30
  },
  "model": {
    "demandPolicy": "buildings-v1",
    "multiplier": 0.04,
    "calibrationStatus": "unvalidated-transfer",
    "seeds": [1, 2],
    "warmupMinutes": 10,
    "firstSlotMin": 360,
    "slotMinutes": 30,
    "slotCount": 32
  },
  "features": {
    "lanes": true,
    "decks": true,
    "lanePath": true,
    "traffic": true,
    "landmarks": true,
    "ownBuildings": true,
    "transit": false,
    "busRouting": false,
    "cameras": false,
    "overture": false,
    "tripProfiles": false
  },
  "budgets": {
    "archivesBytes": 40000000,
    "trafficBytes": 8000000,
    "lanesBytes": 20000000,
    "decksGzipBytes": 1500000,
    "nativeSetBytes": 63000000,
    "buildRssGiB": 24,
    "maxWorkers": 4,
    "citySetBytes": 150000000
  },
  "bboxes": {
    "small": {
      "id": "astana-small",
      "title": "Астана: левый берег (тестовый квадрат)",
      "south": 51.09,
      "west": 71.4,
      "north": 51.135,
      "east": 71.445,
      "tilesPerSide": 1
    },
    "city": {
      "id": "astana-city",
      "title": "Астана целиком",
      "south": 50.95,
      "west": 71.2,
      "north": 51.3,
      "east": 71.7,
      "tilesPerSide": 8
    }
  },
  "auditRegions": {
    "center": {
      "south": 51.09,
      "west": 71.4,
      "north": 51.135,
      "east": 71.445
    }
  },
  "assumptions": [
    "Перенесено из Алматы без проверки по поездкам Астаны: спрос зданий buildings-v1, множитель 0,04, суточная кривая SimConfig.",
    "Перенесено из Алматы: эвристика часов, пустая часовая калибровка, пределы местных улиц 30/40/20/15 км/ч, стоимость классов и модель выездов.",
    "Задержки светофоров 10/15/20 с, справа ×0,5, service entry 15 с — справочные допущения.",
    "D44: полное ожидание на светофорах после модельных линков, множители скоростей 1; допущение, не измерение Астаны.",
    "Схлопывание стоп-линий 30 м — перенесённое допущение.",
    "Motorway → trunk, motorway_link → trunk_link; исходные OSM-теги сохранены, класс имеет provenance default.",
    "Транспорт, камеры, ориентиры, Overture и профили поездок отключены."
  ],
  "status": "live"
}
